<template>
  <div>
    <!-- 상단 제목 -->
    <div class="topbanner">
      <h2>인터넷 콜 접수</h2>
    </div>
    <!--// 상단 제목 -->
    <!-- 메인 컨텐츠 영역 -->
    <div class="topmsg">
      <div class="form-group" ref="menuBtnCall" v-show="true">

<!--        call : {{ this.callInfo }} // {{ this.drvId }}-->

        <span v-if="callInfo == null">접수된 내역이 없습니다.</span>
        <span v-if="callInfo != null && (callInfo.ds_status === 1 || callInfo.ds_status === 2)">콜 접수가 완료되었습니다.</span>
        <span v-if="callInfo != null && (callInfo.ds_status === 3 || callInfo.ds_status === 12 || callInfo.ds_status === 13)">차량을 알아보고 있습니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 4">연결 가능한 차량이 없습니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 5 && callInfo.acs_drvid == null">차량을 알아보고 있습니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 5 && callInfo.acs_drvid != null">
          차량이 연결되었습니다.
          <hr>
          차량 현재 위치는 <strong :style="{ color: '#0b0b0b' }">{{ driverLocation }}</strong>입니다.
        </span>
        <span v-if="callInfo != null && callInfo.ds_status === 6">차량이 출발지에 도착하였습니다. 탑승하여 주세요.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 7">승차중입니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 8">차량에서 하차하였습니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 9">콜 접수가 취소되었습니다.</span>
        <span v-if="callInfo != null && callInfo.ds_status === 10">
          예약 접수되었습니다.<br>
          <small>※ 예약 콜은 전화로만 취소 가능합니다. (1600-4477)</small><br>
          <small>※ 예약 콜과 별개로 일반 콜 접수가 가능합니다.</small>
        </span>
        <button class="btn_common" @click="callCancel"
                v-if="callInfo != null && ( (callInfo.ds_status <= 4 || callInfo.ds_status === 12 || callInfo.ds_status === 13) || (callInfo.ds_status === 5 && callInfo.acs_drvid == null))">
          접수 취소
        </button>

      </div>
    </div>

<!--    {{callInfo}}-->
    <div v-if="callInfo != null && callInfo.acs_drvid !=null && (callInfo.ds_status === 5 || callInfo.ds_status === 6)">
      <div
          id="dispatchModeMap"
          style="width: 98%; height: 400px; border: 1px solid black; margin: 5px;"></div>
      <div id="menu_wrap" style="margin: 5px;">
        <button @click="focusDriverOnMap()">지도에서 기사 위치 찾기</button>
<!--        <button @click="focusMeOnMap()">지도에서 내 위치 찾기</button>-->
      </div>
    </div>

    <!-- 콜 접수 버튼 -->
    <article v-if="callInfo == null || callInfo.ds_status === 10" class="main_contents">
      <ul class="accept_in_wrap">
<!--        <li class="btn_accept_in" @click="call"><a href="javascript:void(0);">바로 콜 접수하기</a></li>-->
        <li class="btn_accept_in" @click="call($event)">
          <a href="javascript:void(0);" aria-label="바로 콜 접수하기 버튼">바로 콜 접수하기</a>
        </li>
        <!--li class="btn_accept_disabled" @click="sharingCall">합승 콜 접수하기</li-->
      </ul>
      <div class="btn_bottom">
        <button class="btn_common" @click="infoLink">인터넷 콜 접수 이용안내</button>
      </div>
    </article>
    <!--// 메인 컨텐츠 영역 -->
  </div>
</template>

<script>
import blueCar from "@/assets/res/cblue_4.png";
import grayCar from "@/assets/res/cgray_4.png";
import pinkCar from "@/assets/res/cpink_4.png";
import redCar from "@/assets/res/cred_4.png";
import yellowCar from "@/assets/res/cyellow_4.png";
import axios from "axios";
import process from "shelljs";
import callPreCheck from '../../mixins/callPreCheck';

export default {
  data() {
    return {
      callInfo: null,

      driverPositionData: [], // 차량 위치 데이터
      callReceptionData: [],  // 콜 접수 데이터
      naverMap: null,         // 네이버 지도 객체
      markers: [],            // 지도 마커 배열
      carIcons: [blueCar, grayCar, pinkCar, redCar, yellowCar], // 차량 아이콘 배열

      driverStatus: null,
      driverLocation: "",
      drvId: null,
      drvLatLng: null,

      checkCallInterval: null,

      mapInitialized: false,
    }
  },

  async mounted() {
    await this.progress();

    if (this.callInfo && this.callInfo.acs_drvid !== null && (this.callInfo.ds_status === 5 || this.callInfo.ds_status === 6)) {
      console.log(this.callInfo);
      console.log("in");
      await this.initMap(this.callInfo.no_frY, this.callInfo.no_frX, 15);

      console.log("1");
      if (this.callInfo.acs_drvid) {
        this.drvId = this.callInfo.acs_drvid;

        console.log("2");
        await this.getDriverStatus(this.drvId);
        console.log("3");
      }
      console.log("out");
    }

    this.checkCallInterval = setInterval(() => {
      this.progress();
      if (this.callInfo.acs_drvid != null) {
        this.getDriverStatus(this.callInfo.acs_drvid);
      }
    }, 5000);

    // 페이지 로드 후 특정 요소로 포커스 이동
    this.$nextTick(() => {
      const menuBtnCall = this.$refs.menuBtnCall;
      if (menuBtnCall) {
        menuBtnCall.focus();
      } else {
        console.error('menuBtnCall is not defined');
      }
    });
  },

  beforeDestroy() {
    if (this.checkCallInterval) {
      clearInterval(this.checkCallInterval);
    }
  },

  mixins: [callPreCheck],
  methods: {
    async progress() {

      await this.$http.get('/api/order/progress.do').then(async (response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          if (response.data.callInfo.ds_status === 8) {
            this.callInfo = null;
            return;
          }

          if (response.data.callInfo.acs_drvid) {
            this.drvId = response.data.acs_drvid;
          }
          const threeDaysAgo = new Date();
          threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);

          const receiveDateStr = response.data.callInfo.receive_date;
          const year = parseInt(receiveDateStr.slice(0, 4));
          const month = parseInt(receiveDateStr.slice(4, 6)) - 1;
          const day = parseInt(receiveDateStr.slice(6, 8));
          const receiveDate = new Date(year, month, day);

          if (receiveDate >= threeDaysAgo) {
            this.callInfo = response.data.callInfo;
          }

          console.log(this.mapInitialized);
          console.log(this.callInfo.acs_drvid);
          console.log(this.callInfo.ds_status);

          if (
              !this.mapInitialized &&
              this.callInfo.acs_drvid &&
              this.callInfo.ds_status === 5
          ) {
            await this.initMap(this.callInfo.no_frY, this.callInfo.no_frX, 15);
            await this.getDriverStatus(this.callInfo.acs_drvid);
            this.mapInitialized = true;
          }

        }
      });

    },
    call() {
      this.callPreCheckThen(() => {
        alert("대기, 왕복콜은 센터로 접수해주시기 바랍니다.");
        this.$router.push("/m/order/call");
      });
    },
    callCancel() {
      if (this.callInfo == null) {
        return;
      }

      if (!confirm("접수를 취소하시겠습니까?")) {
        return;
      }

      this.$http.get('/api/order/callCancel.do', {
        params: {
          date: this.callInfo.receive_date,
          seq: this.callInfo.receive_seq
        }
      }).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          alert("접수가 취소 되었습니다.");
          location.reload();
        } else {
          if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
            this.$store.commit("setSession", null);
            this.$router.push({path: "/m/login", query: {return_url: "/m/order/main"}});
          } else {
            alert("접수 취소를 실패 하였습니다. [error_code:" + response.data.retval + "]");
            location.reload();
          }
        }
      });
    },
    infoLink() {
      this.$router.push("/m/sub/10");
    },
    sharingCall() {
      alert("서비스 준비 중입니다.");
    },

    async initMap(dblLat, dblLng, nZoomLevel) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=e7o30z0yhy";
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        script.onload = () => {
          // 네이버 지도 초기화
          this.naverMap = new window.naver.maps.Map("dispatchModeMap", {
            center: new window.naver.maps.LatLng(dblLat, dblLng),
            zoom: nZoomLevel,
          });

          const marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(this.callInfo.no_frY, this.callInfo.no_frX),
            map: this.naverMap
          });

          resolve(); // 초기화가 완료되었음을 알림
        };

        script.onerror = () => {
          reject(new Error("Failed to load Naver Map Script"));
        };
      });
    },

    async drawCar(lat, lng, msg) {
      const position = new naver.maps.LatLng(lat, lng);

      const markerOptions = {
        position: position.destinationPoint(90, 15),
        map: this.naverMap,
        icon: {
          // url: this.carIcons[0],
          content:
              '<img src="' + this.carIcons[0] + '" alt="" ' +
              // 'style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block; max-width: none; max-height: none; ' +
              '-webkit-user-select: none; position: absolute; width: 22px; height: 35px; left: 0px; top: 0px;">'
              +
              '<div style="' +
              // 'position: absolute; ' +
              'background-color: #ffff00; ' + /* 노란 배경 */
              // 'padding: 5px; ' +
              'font-size: 12px; ' +
              'font-weight: bold; ' +
              'color: #000000; ' + /* 검정 텍스트 */
              'transform: translate(-33%, 0); ' + /* 가로 가운데 정렬 */
              ' transition: opacity 0.3s; ' + /* 부드러운 전환 효과 */
              'text-align: center; ' +
              'vertical-align: middle; ' +
              'white-space: nowrap;' +
              'top: 40px; ' + /* 추가 스타일: 이미지 바로 아래로 이동 */
              '">' +
              msg +
              '</div>',
          size: new naver.maps.Size(50, 52),
          origin: new naver.maps.Point(0, 0),
          anchor: new naver.maps.Point(25, 26)
        }
      };

      const marker = new naver.maps.Marker(markerOptions);

      this.markers.push(marker);
    },

    removeAllMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    },

    async getDriverStatus(drvid) {
      try {
        const url = "/api/order/driver.do";
        // const url = process.env.VUE_APP_API_URL + "/order/driver.do";

        const response = await axios.post(
            url,
            {pkDrvid: drvid},
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
        );
        if (response.data.code === "0000") {
          this.removeAllMarkers();
          const drvStatus = response.data.data;

          const dblLng = drvStatus.noX.toString();
          const dblLat = drvStatus.noY.toString();

          const lng = parseFloat(dblLng.substring(0, 3) + "." + dblLng.substring(3));
          const lat = parseFloat(dblLat.substring(0, 2) + "." + dblLat.substring(2));
          const msg = [drvStatus.nmSido, drvStatus.nmGugun, drvStatus.nmDong].join(" ");

          this.driverLocation = msg;
          await this.drawCar(lat, lng, msg);

          this.drvLatLng = new naver.maps.LatLng(lat, lng);
        }
      } catch (err) {
        console.log(err);
      }
    },
    focusDriverOnMap() {
      this.naverMap.setCenter(this.drvLatLng);
    },
    focusMeOnMap() {
      this.naverMap.setCenter(new naver.maps.LatLng(this.callInfo.no_frY, this.callInfo.no_frX));
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/pages/order/Main.vue